// extracted by mini-css-extract-plugin
export default {"scrollContainer":"scrollContainer--FozU2","list":"list--pfhIA","wrapper":"wrapper--L40tT","item":"item--N8eDB"};